import { Link } from 'react-router-dom';
import { ArrowLeft, Shield } from 'lucide-react';

export default function Terms() {
  return (
    <div className="p-4 md:p-6 max-w-3xl mx-auto">
      <Link to="/" className="flex items-center gap-2 text-text-muted hover:text-text-primary mb-6">
        <ArrowLeft size={16} /> Back
      </Link>

      <div className="flex items-center gap-2 mb-6">
        <Shield size={20} className="text-accent" />
        <h1 className="text-xl font-bold">Terms of Service</h1>
      </div>

      <div className="card space-y-5 text-sm text-text-muted leading-relaxed">
        <p><strong className="text-text-primary">Last updated:</strong> July 2026</p>

        <section>
          <h2 className="text-text-primary font-semibold mb-2">1. Acceptance of Terms</h2>
          <p>By using ApexDev ("the Service"), you agree to these Terms of Service. If you do not agree, do not use the Service.</p>
        </section>

        <section>
          <h2 className="text-text-primary font-semibold mb-2">2. Description of Service</h2>
          <p>ApexDev provides free static website hosting. Users can upload HTML, CSS, JavaScript, and other static files which are served via subdomains on meganhost.dpdns.org.</p>
        </section>

        <section>
          <h2 className="text-text-primary font-semibold mb-2">3. User Responsibilities</h2>
          <p>You agree not to:</p>
          <ul className="list-disc ml-4 mt-1 space-y-1">
            <li>Host illegal content, malware, phishing pages, or any content violating Kenyan or international law</li>
            <li>Use the Service for spam, scams, or fraudulent activity</li>
            <li>Attempt to breach, exploit, or overload the Service infrastructure</li>
            <li>Host content that infringes on others' intellectual property rights</li>
          </ul>
        </section>

        <section>
          <h2 className="text-text-primary font-semibold mb-2">4. Content Ownership</h2>
          <p>You retain all rights to the content you upload. ApexDev does not claim ownership of your files. We reserve the right to remove content that violates these terms.</p>
        </section>

        <section>
          <h2 className="text-text-primary font-semibold mb-2">5. Service Availability</h2>
          <p>ApexDev is provided free of charge. While we strive for high availability, we do not guarantee 100% uptime. The Service may be interrupted for maintenance, updates, or reasons beyond our control.</p>
        </section>

        <section>
          <h2 className="text-text-primary font-semibold mb-2">6. Limitation of Liability</h2>
          <p>ApexDev is provided "as is" without warranties of any kind. We are not liable for any damages arising from the use or inability to use the Service, including data loss or service interruptions.</p>
        </section>

        <section>
          <h2 className="text-text-primary font-semibold mb-2">7. Termination</h2>
          <p>We reserve the right to suspend or terminate access to the Service for violations of these terms, without prior notice.</p>
        </section>

        <section>
          <h2 className="text-text-primary font-semibold mb-2">8. Contact</h2>
          <p>For questions about these terms:</p>
          <div className="mt-2 space-y-1 text-xs">
            <p>📧 Email: <a href="mailto:trackerwanga@gmail.com" className="text-accent hover:underline">trackerwanga@gmail.com</a></p>
            <p>📱 WhatsApp: <a href="https://wa.me/254769502217" className="text-accent hover:underline" target="_blank" rel="noopener noreferrer">+254 769 502 217</a></p>
            <p>📞 Call: <a href="tel:+254758476795" className="text-accent hover:underline">+254 758 476 795</a></p>
          </div>
        </section>
      </div>
    </div>
  );
}
